// app-insights.interceptor.ts
import { HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { tap } from 'rxjs/operators';
import { ApplicationInsightsService } from '@core/services';

export function appInsightsInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn) {
  const appInsights = inject(ApplicationInsightsService);
  const startTime = Date.now();
  const requestId = Math.random().toString(36).substring(2, 9);

  return next(req).pipe(
    tap({
      next: (event) => {
        appInsights.logHttpEvent(startTime, requestId, req, event);
      },
      error: (error) => {
        appInsights.logHttpEvent(startTime, requestId, req, error);
      }
    })
  );
}